import axios from 'axios';
import { fetchWrapper } from '@/helpers';

const localApiNotificationUrl =
  process.env.VUE_APP_PROXY_SERVER + '/api/Notification';

class NotificationApi {
  async registerToken(token, userId) {
    const url = `${localApiNotificationUrl}/registerToken`;

    const requestBody = {
      token: token,
      userId: userId,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error registering token:', error);
      throw error;
    }
  }

  async subscribeToTopic(token, topic) {
    const url = `${localApiNotificationUrl}/subscribeToTopic`;

    const requestBody = {
      token: token,
      topic: topic,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to topic:', error);
      throw error;
    }
  }

  async unsubscribeFromTopic(token, topic) {
    const url = `${localApiNotificationUrl}/unsubscribeFromTopic`;

    const requestBody = {
      token: token,
      topic: topic,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error unsubscribing from topic:', error);
      throw error;
    }
  }

  async sendNotification(token, title, body) {
    const url = `${localApiNotificationUrl}/send`;

    const requestBody = {
      token: token,
      title: title,
      body: body,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error sending notification:', error);
      throw error;
    }
  }

  async sendNotificationToTopic(topic, title, body) {
    const url = `${localApiNotificationUrl}/sendToTopic`;

    const requestBody = {
      topic: topic,
      title: title,
      body: body,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error sending notification to topic:', error);
      throw error;
    }
  }

  async sendNotificationToMultipleTokens(tokens, title, body) {
    const url = `${localApiNotificationUrl}/sendToMultipleTokens`;

    const requestBody = {
      tokens: tokens,
      title: title,
      body: body,
    };

    try {
      const response = await axios.post(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error sending notifications to multiple tokens:', error);
      throw error;
    }
  }

  async validateToken(token) {
    const url = `${localApiNotificationUrl}/validate`;

    try {
      const response = await axios.post(url, null, {
        params: { token: token },
      });
      return response.data;
    } catch (error) {
      console.error('Error validating token:', error);
      throw error;
    }
  }

  async getNotifications(userId, pageNumber = 1, pageSize = 10) {
    var url = `${localApiNotificationUrl}/getNotifications?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

    return fetchWrapper.get(url);
  }

  async markAsRead(notificationId) {
    const url = `${localApiNotificationUrl}/markAsRead/${notificationId}`;
    try {
      await axios.post(url);
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  async markAllAsRead(userId) {
    const url = `${localApiNotificationUrl}/markAllAsRead?userId=${userId}`;
    try {
      await axios.post(url);
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  async getUnreadCount(userId) {
    const url = `${localApiNotificationUrl}/unreadCount?userId=${userId}`;
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      throw error;
    }
  }

  async deleteOldNotifications(days, isReadOnly = false) {
    const url = `${localApiNotificationUrl}/deleteNotifications`;
    return fetchWrapper.delete(url, { days, isReadOnly });
  }
}

export default new NotificationApi();
